import { Asset, MimeType } from '@facephi/inphinite-common';
import {
  FlexContainer,
  IconName,
  OptionMenu,
  OptionMenuItem,
} from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import {
  StyledChips,
  TableAssetsContainer,
  TableAssetsDropdown,
  TableAssetsStyles,
  TableAssetsVideoCall,
} from './Styles';

type IProps = {
  assets?: Asset[];
  onVideoCall?(): void;
  disabled?: boolean;
  onClick?(position: number): void;
  dataTour?: string;
};

export const TableAssets = ({
  assets = [],
  onVideoCall,
  disabled,
  onClick,
  dataTour,
}: IProps) => {
  const { t } = useTranslation();

  const icon: Record<MimeType, IconName> = {
    [MimeType.jpg]: 'FileArrowDown',
    [MimeType.jpeg]: 'FileArrowDown',
    [MimeType.png]: 'FileArrowDown',
    [MimeType.pdf]: 'FilePdf',
    [MimeType.mp4]: 'VideoCamera',
    [MimeType.wav]: 'Microphone',
  };

  const getIcon = (contentType: MimeType): IconName => {
    return icon[contentType] ? icon[contentType] : icon[MimeType.jpg];
  };

  const onClickAsset = (position: number) => {
    onClick && onClick(position);
  };

  return (
    <TableAssetsContainer>
      <TableAssetsStyles alignItems="center" justifyContent="center">
        <FlexContainer data-tour={assets.length ? dataTour : ''}>
          <FlexContainer alignItems="center">
            {assets?.length ? (
              <OptionMenu
                renderItem={
                  <TableAssetsDropdown alignItems="center" columnGap="0.8">
                    <StyledChips
                      label={`${t('Files')} (${assets.length.toString()})`}
                    />
                  </TableAssetsDropdown>
                }
              >
                {assets.map((item, index) => (
                  <OptionMenuItem
                    key={index}
                    iconName={getIcon(item.contentType)}
                    onClick={() => onClickAsset(index)}
                    disabled={disabled}
                  >
                    {t(item.type)}
                  </OptionMenuItem>
                ))}
              </OptionMenu>
            ) : (
              <></>
            )}
          </FlexContainer>
        </FlexContainer>

        {onVideoCall && (
          <TableAssetsVideoCall iconName="Headset" onClick={onVideoCall} />
        )}
      </TableAssetsStyles>
    </TableAssetsContainer>
  );
};
